import en_us from './en_us';
import es_us from './es_us';
import es_sp from './es_sp';
import nl_nl from './nl_nl';
import it_it from './it_it';
import fr_ca from './fr_ca';

export default {
  en: en_us,
  'en-US': en_us,
  es: es_us,
  'es-US': es_us,
  'es-ES': es_sp,
  nl: nl_nl,
  'nl-NL': nl_nl,
  it: it_it,
  'it-IT': it_it,
  fr: fr_ca,
  'fr-CA': fr_ca,
};
